import { render, staticRenderFns } from "./MenuLayer.vue?vue&type=template&id=0aa8e666&scoped=true&"
import script from "./MenuLayer.vue?vue&type=script&lang=js&"
export * from "./MenuLayer.vue?vue&type=script&lang=js&"
import style0 from "./MenuLayer.vue?vue&type=style&index=0&id=0aa8e666&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa8e666",
  null
  
)

export default component.exports